module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-vertical-line.86dc5bb9.png";